import { render, staticRenderFns } from "./assetDepreciationDetail.vue?vue&type=template&id=d917c298"
import script from "./assetDepreciationDetail.vue?vue&type=script&lang=js"
export * from "./assetDepreciationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports